import { IState } from 'shared/store';

export const selectSuburbanBuildersProjects = (state: IState) => {
  return state.suburbanBuildersProjects.slice(0, 4);
};
